import { cn } from "@/lib/utils";
const kudozIcon = "/kudoz-icon-disc-96.webp";

interface KudozDisplayProps {
  amount?: number;
  showIcon?: boolean;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "badge";
  animated?: boolean;
  className?: string;
}

export default function KudozDisplay({
  amount = 0,
  showIcon = true,
  size = "md",
  variant = "default",
  animated = false,
  className,
}: KudozDisplayProps) {
  const sizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
  };

  const iconSizes = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  const baseClasses = cn(
    "flex items-center gap-1 font-semibold",
    sizeClasses[size],
    animated && "transition-all duration-300",
    className
  );

  if (variant === "badge") {
    return (
      <div
        className={cn(
          baseClasses,
          "bg-kudoz text-kudoz-foreground px-2 py-1 rounded-full"
        )}
        data-testid="kudoz-badge"
      >
        {showIcon && (
          <img src={kudozIcon} alt="Kudoz" className={iconSizes[size]} />
        )}
        {(amount ?? 0).toLocaleString()}
      </div>
    );
  }

  return (
    <div className={cn(baseClasses, "text-kudoz")} data-testid="kudoz-display">
      {showIcon && (
        <img src={kudozIcon} alt="Kudoz" className={iconSizes[size]} />
      )}
      <span>{(amount ?? 0).toLocaleString()}</span>
    </div>
  );
}
